import React, { useState, useEffect } from "react";
import { createTwister, updateTwister } from "./adminTongueTwisterService";
import ImagePickerModal from "../media_images/ImagePickerModal";

const BASE_ROOT = process.env.REACT_APP_BASE_URL_ROOT || "";
const toPublicImgSrc = (url) => {
  if (!url) return "";
  const pub = url.replace(/\/api(?:\/admin)?\/media-images\//, "/api/public/media-images/");
  const src = pub.startsWith("http") ? pub : `${BASE_ROOT}${pub}`;
  console.log("[TongueTwisterForm] img raw:", url, "→ resolved:", src);
  return src;
};
const difficultyOptions = ["Easy", "Medium", "Hard"];

const TongueTwisterForm = ({ data, onSaved, onCancel }) => {
 const isEdit = !!data;

 const [form, setForm] = useState({
  title: "",
  description: "",
  pronunciation: "",
  difficulty: "Easy",
  youtubeLink: "",
  imageUrl: "",
 });

 const [loading, setLoading] = useState(false);
 const [showImagePicker, setShowImagePicker] = useState(false);

 useEffect(() => {
  if (data) {
   setForm({
    title: data.title || "",
    description: data.description || "",
    pronunciation: data.pronunciation || "",
    difficulty: data.difficulty || "Easy",
    youtubeLink: data.youtubeLink || "",
    imageUrl: data.imageUrl || "",
   });
  }
 }, [data]);

 const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

 const handleSubmit = async () => {
  if (!form.title || !form.description) { alert("Title and Description are required"); return; }
  const payload = { ...form, ...(form.youtubeLink ? {} : { youtubeLink: undefined }), imageUrl: form.imageUrl || null };
  setLoading(true);
  const res = isEdit ? await updateTwister(data.id, payload) : await createTwister(payload);
  if (res.status === 200 || res.status === 201) { onSaved(); }
  else { alert(res.message || "Operation failed"); }
  setLoading(false);
 };

 return (
  <div className="modal-overlay">
   <div className="modal-content">
    <div className="form-card" style={{ margin: 0, boxShadow: "none" }}>
     <h2>{isEdit ? "Edit" : "Create"} Tongue Twister</h2>

     <div className="form-group">
      <label>Title *</label>
      <input name="title" placeholder="e.g. She Sells Seashells" value={form.title} onChange={handleChange} />
     </div>

     <div className="form-group">
      <label>Description *</label>
      <textarea name="description" placeholder="The full tongue twister text..." value={form.description} onChange={handleChange} rows={3} />
     </div>

     <div className="form-group">
      <label>Pronunciation</label>
      <textarea name="pronunciation" placeholder="e.g. Shee selz see-shelz by thuh see-shore." value={form.pronunciation} onChange={handleChange} rows={2} />
     </div>

     <div className="form-group">
      <label>Difficulty</label>
      <select name="difficulty" value={form.difficulty} onChange={handleChange}>
       {difficultyOptions.map((opt) => <option key={opt} value={opt}>{opt}</option>)}
      </select>
     </div>

     <div className="form-group">
      <label>YouTube Link (optional)</label>
      <input name="youtubeLink" placeholder="https://youtube.com/..." value={form.youtubeLink} onChange={handleChange} />
     </div>

     <div className="form-group">
      <label>Image (optional)</label>
      <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
       {form.imageUrl ? (
        <img src={toPublicImgSrc(form.imageUrl)} alt="selected"
         style={{ width: 60, height: 60, objectFit: "contain", background: "#f5f5f5", borderRadius: 8, border: "1px solid #ddd" }} />
       ) : (
        <div style={{ width: 60, height: 60, background: "#f0f0f0", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, color: "#aaa" }}>No image</div>
       )}
       <button type="button" className="btn secondary" onClick={() => setShowImagePicker(true)}>Pick Image</button>
       {form.imageUrl && (
        <button type="button" className="btn secondary" onClick={() => setForm({ ...form, imageUrl: "" })}>Clear</button>
       )}
      </div>
     </div>

     <div className="form-actions">
      <button onClick={handleSubmit} disabled={loading}>{loading ? "Saving..." : isEdit ? "Update" : "Create"}</button>
      <button onClick={onCancel} disabled={loading}>Cancel</button>
     </div>
    </div>
   </div>

   <ImagePickerModal
    isOpen={showImagePicker}
    onClose={() => setShowImagePicker(false)}
    onSelect={(url) => { setForm({ ...form, imageUrl: url }); setShowImagePicker(false); }}
    defaultImageUse="GENERAL"
   />
  </div>
 );
};

export default TongueTwisterForm;
